module.exports = __webpack_public_path__ + "static/media/maps-marker.ff8df8bf.svg";